import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { IconName } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import { getCurrentEnterpriseUserPreferredServiceId } from '@mews-commander/legacy-entities/src/selectors/session/enterprise';
import {
    isCurrentEnterpriseServiceProviderWithBookableService,
    isCurrentEnterpriseCheckoutReportEnabled,
} from '@mews-commander/legacy-entities/src/selectors/session/subscription';
import {
    canCurrentProfileManageReservations,
    canCurrentProfileManageRates,
    canCurrentEmployeeUseTimeline,
} from '@mews-commander/legacy-entities/src/selectors/session/scope';
import { NEW_RESERVATION_SCREEN_SHORTCUT, RESERVATION_OVERVIEW_SHORTCUT, TIMELINE_SHORTCUT } from '../../shortcuts';
import { createListItemWithLink } from '../helpers';
import { SidebarExpandableListItem, SidebarFontIcon } from '../style';
import { NEW_RESERVATION_BUTTON_DATA_TEST_ID } from '../../newReservation/constants';

const ReservationsMenu = ({
    isServiceProvider,
    canManageReservations,
    canManageRates,
    canUseTimeline,
    enterpriseId,
    serviceId,
    checkoutReportEnabled,
    ...other
}: $TSFixMe) =>
    isServiceProvider ? (
        <SidebarExpandableListItem
            leftIcon={<SidebarFontIcon value={IconName.Reservations} />}
            primaryText={<LocalizedText textKey={TextKey.ReservationPlural} />}
            {...other}
        >
            {canManageReservations
                ? createListItemWithLink({
                      textKey: TextKey.CreateReservation,
                      iconName: IconName.Add,
                      tooltip: NEW_RESERVATION_SCREEN_SHORTCUT,
                      path: 'Reservation/Create',
                      dataTestId: NEW_RESERVATION_BUTTON_DATA_TEST_ID,
                  })
                : null}
            {canUseTimeline
                ? createListItemWithLink({
                      textKey: TextKey.TimeLine,
                      iconName: IconName.Timeline,
                      tooltip: TIMELINE_SHORTCUT,
                      path: 'Reservation/Dashboard',
                      search: { ServiceId: serviceId },
                  })
                : null}
            {checkoutReportEnabled
                ? createListItemWithLink({
                      textKey: TextKey.CheckoutReport,
                      iconName: IconName.Checkout,
                      path: 'CheckoutReport/Index',
                      search: { 'Service.Id': serviceId },
                  })
                : null}
            {createListItemWithLink({
                textKey: TextKey.ReservationReport,
                iconName: IconName.SummaryOrder,
                path: 'ReservationReport/Index',
                search: { 'Service.Id': serviceId },
            })}
            {createListItemWithLink({
                textKey: TextKey.ReservationSourceReport,
                iconName: IconName.SummaryOrder,
                path: 'ReservationSourceReport/Index',
                search: { 'Service.Id': serviceId },
            })}
            {createListItemWithLink({
                textKey: TextKey.ReservationOverview,
                iconName: IconName.ReservationPreview,
                tooltip: RESERVATION_OVERVIEW_SHORTCUT,
                path: 'ReservationOverviewReport/Index',
                search: { 'Service.Id': serviceId },
            })}
            {createListItemWithLink({
                textKey: TextKey.AvailabilityOccupancyReport,
                iconName: IconName.Availability,
                path: 'AvailabilityReport/Index',
                search: { PartialBind: true, ScopeId: enterpriseId, 'Services.Id[]': serviceId },
            })}
            {createListItemWithLink({
                textKey: TextKey.AvailabilityBlockReport,
                iconName: IconName.Website,
                path: 'AvailabilityBlockReport/Index',
            })}
            {canManageRates
                ? createListItemWithLink({
                      textKey: TextKey.RateManagement,
                      iconName: IconName.RateManagement,
                      path: 'Visit/DefaultPricing/$serviceId',
                      params: {
                          serviceId,
                      },
                  })
                : null}
        </SidebarExpandableListItem>
    ) : null;

export default connect(
    createStructuredSelector({
        isServiceProvider: isCurrentEnterpriseServiceProviderWithBookableService,
        enterpriseId: getCurrentEnterpriseId,
        serviceId: getCurrentEnterpriseUserPreferredServiceId,
        canManageReservations: canCurrentProfileManageReservations,
        canUseTimeline: canCurrentEmployeeUseTimeline,
        canManageRates: canCurrentProfileManageRates,
        checkoutReportEnabled: isCurrentEnterpriseCheckoutReportEnabled,
    })
)(ReservationsMenu);
